import React from "react";
import "./Headermypr.css";

export const Headermypr = () => {
    return(
        <div className="Myproject_br">
            <div className="Project">My Projects</div>
        </div>
    );
}